import { render, staticRenderFns } from "./DicInput.vue?vue&type=template&id=a683b2f4&scoped=true&"
import script from "./DicInput.vue?vue&type=script&lang=js&"
export * from "./DicInput.vue?vue&type=script&lang=js&"
import style0 from "./DicInput.vue?vue&type=style&index=0&id=a683b2f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a683b2f4",
  null
  
)

export default component.exports